import React, { useState } from 'react';

const InchInput = ({ value, onChange, placeholder, required, className }) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  
  // Fraction mapping for 16ths
  const fractionMapping = {
    "0.0000": "0",
    "0.0625": "1/16",
    "0.1250": "1/8",
    "0.1875": "3/16",
    "0.2500": "1/4",
    "0.3125": "5/16",
    "0.3750": "3/8",
    "0.4375": "7/16",
    "0.5000": "1/2",
    "0.5625": "9/16",
    "0.6250": "5/8",
    "0.6875": "11/16",
    "0.7500": "3/4",
    "0.8125": "13/16",
    "0.8750": "7/8",
    "0.9375": "15/16"
  };

  // Inch options for the modal
  const inchOptions = [
    { label: "0", value: "0" },
    { label: "1/16", value: "0.0625" },
    { label: "1/8", value: "0.125" },
    { label: "3/16", value: "0.1875" },
    { label: "1/4", value: "0.25" },
    { label: "5/16", value: "0.3125" },
    { label: "3/8", value: "0.375" },
    { label: "7/16", value: "0.4375" },
    { label: "1/2", value: "0.5" },
    { label: "9/16", value: "0.5625" },
    { label: "5/8", value: "0.625" },
    { label: "11/16", value: "0.6875" },
    { label: "3/4", value: "0.75" },
    { label: "13/16", value: "0.8125" },
    { label: "7/8", value: "0.875" },
    { label: "15/16", value: "0.9375" }
  ];

  const safeValue = value && !isNaN(parseFloat(value)) ? value : "0";
  const whole = parseInt(safeValue, 10) || 0;
  const fraction = parseFloat(safeValue) - whole;
  
  // Convert decimal fraction to closest 1/16th
  const convertToClosestSixteenth = (decimal) => {
    const sixteenths = Math.round(decimal * 16) / 16;
    return parseFloat(sixteenths.toFixed(4)).toString();
  };
  
  const closestSixteenth = convertToClosestSixteenth(fraction);
  const fractionDecimal = parseFloat(closestSixteenth).toFixed(4); // Ensure 4 decimal places for mapping
  const fractionDisplayLabel = fractionMapping[fractionDecimal] || fractionDecimal;

  const handleFractionChange = (newFractionValue) => {
    const combined = whole + parseFloat(newFractionValue);
    onChange(combined.toString());
    setIsModalVisible(false);
  };

  const handleWholeChange = (text) => {
    const newWhole = parseInt(text, 10) || 0;
    onChange((newWhole + fraction).toString());
  };

  return (
    <div className="flex items-center space-x-2">
      {/* Whole number input */}
      <input
        type="number"
        value={whole.toString()}
        onChange={(e) => handleWholeChange(e.target.value)}
        className={`flex-1 border rounded-lg py-2 px-3 focus:ring-2 focus:ring-blue-500 focus:border-transparent ${className || 'border-gray-300'}`}
        placeholder={placeholder}
        required={required}
        min="0"
        step="1"
      />
      
      {/* Fraction button */}
      <button
        type="button"
        onClick={() => setIsModalVisible(true)}
        className="px-3 py-2 border border-gray-300 rounded-lg bg-gray-50 hover:bg-gray-100 focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm font-medium"
      >
        {fractionDisplayLabel}
      </button>

      {/* Fraction picker modal */}
      {isModalVisible && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 max-w-sm w-full mx-4 max-h-96 overflow-y-auto">
            <h3 className="text-lg font-medium text-gray-900 mb-4">Select Fraction</h3>
            <div className="space-y-2">
              {inchOptions.map((option) => (
                <button
                  key={option.value}
                  onClick={() => handleFractionChange(option.value)}
                  className={`w-full text-left px-4 py-2 rounded-lg hover:bg-blue-50 ${
                    fractionDisplayLabel === option.label 
                      ? 'bg-blue-100 text-blue-800 font-medium' 
                      : 'text-gray-700'
                  }`}
                >
                  {option.label}
                </button>
              ))}
            </div>
            <div className="mt-4 flex justify-end">
              <button
                onClick={() => setIsModalVisible(false)}
                className="px-4 py-2 text-gray-600 hover:text-gray-800"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default InchInput;
